import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import logoSmall from '../../assets/logo-small.png';
import nexoLogo from '../../assets/nexo-logo.png';
import '../../styles/navbar.css';

function NavBar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    setIsMenuOpen(false);
  };

  const handleBrandClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleChangePassword = () => {
    navigate('/change-password');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isDropdownOpen) setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand-container" onClick={handleBrandClick}>
        <img src={logoSmall} alt="Club Logo" className="navbar-logo" />
        <span className="navbar-brand-text">Club</span>
        <img src={nexoLogo} alt="Nexo Logo" className="nexo-logo" />
      </div>

      {/* Botón de hamburguesa (visible solo en móviles) */}
      <button className="hamburger" onClick={toggleMenu}>
        {isMenuOpen ? '✖' : '☰'}
      </button>

      {/* Enlaces de navegación */}
      <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <div className="main-links">
          <Link
            to="/quienes-somos"
            className={location.pathname === '/quienes-somos' ? 'active' : ''}
            onClick={handleLinkClick}
          >
            Quiénes Somos
          </Link>
          <Link
            to="/fotos"
            className={location.pathname === '/fotos' ? 'active' : ''}
            onClick={handleLinkClick}
          >
            Fotos
          </Link>
          {user && (
            <Link
              to="/reserva-salas"
              className={location.pathname === '/reserva-salas' ? 'active' : ''}
              onClick={handleLinkClick}
            >
              Reserva Salas
            </Link>
          )}
          <Link
            to="/calendario"
            className={location.pathname === '/calendario' ? 'active' : ''}
            onClick={handleLinkClick}
          >
            Calendario
          </Link>
          <Link
            to="/contacto"
            className={location.pathname === '/contacto' ? 'active' : ''}
            onClick={handleLinkClick}
          >
            Contacto
          </Link>
          {user && user.rol === 'administrador' && (
            <Link
              to="/gestion-solicitudes"
              className={location.pathname === '/gestion-solicitudes' ? 'active' : ''}
              onClick={handleLinkClick}
            >
              Gestionar Solicitudes
            </Link>
          )}
        </div>

        {/* Separador y sección de usuario */}
        {user ? (
          <div
            className="user-section"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <hr className="menu-divider" />
            <span className="user-name" onClick={toggleDropdown}>
              Bienvenido, {user.first_name}
            </span>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <button onClick={handleChangePassword} className="dropdown-item">
                  Cambiar Contraseña
                </button>
                <button onClick={handleLogout} className="dropdown-item">
                  Cerrar Sesión
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="auth-links">
            <Link
              to="/login"
              className={location.pathname === '/login' ? 'active' : ''}
              onClick={handleLinkClick}
            >
              Iniciar Sesión
            </Link>
            <Link
              to="/registro"
              className={location.pathname === '/registro' ? 'active' : ''}
              onClick={handleLinkClick}
            >
              Registrarse
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}

export default NavBar;